import { render, staticRenderFns } from "./Penarikan.vue?vue&type=template&id=7dd1dbc2"
import script from "./Penarikan.vue?vue&type=script&lang=js"
export * from "./Penarikan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports